import { render, staticRenderFns } from "./Testcheck.vue?vue&type=template&id=3bacddb4"
import script from "./Testcheck.vue?vue&type=script&lang=js"
export * from "./Testcheck.vue?vue&type=script&lang=js"
import style0 from "./Testcheck.vue?vue&type=style&index=0&id=3bacddb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports